module.exports = __webpack_public_path__ + "img/smart-blending-program.76ffbdc2.png";